<nb-card class="additional-questions-card">
	<nb-card-body>
		<div>
			<div class="card-header-wrapper">
				<h5 id="card-header" [ngClass]="{'collapsed': !detailsVisible}">
					{{ 'additional-questions.title' | translate }}
				</h5>
				@if (collapsable) {
					<a id="toggle-order-details" class="toggle-details-section" (click)="detailsVisible = !detailsVisible" data-test-id="additional-questions-details-toggle">
						{{ (detailsVisible ? 'common.hide' : 'common.show') | translate }}
						<nb-icon icon="{{detailsVisible ? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline'}}"></nb-icon>
					</a>
				}
			</div>

			@if (detailsVisible) {
				<div id="additional-questions-details" class="row-wrapper">
					<div class="col-md-12">
						@for (product of order.products; track $index) {
							<h6 id="header">{{ 'common.iso-certification-sub-title' | translate: {standard: product.standard.name | standardName} }}</h6>
							@if (isTransfer(product)) {
								<transfer-additional-questions-details [changeSet]="changeSet" [product]="product" [translateClientsData]="translateClientsData"
																	   [useOriginalTranslations]="useOriginalTranslations"></transfer-additional-questions-details>
							}
							@if (isFirstYearInitial(product)) {
								<initial-additional-questions-details [changeSet]="changeSet" [product]="product" [clientCountry]="order.clientCountry"></initial-additional-questions-details>
							}
							@if (!isTransfer(product) && (isRecertification(product) || !isFirstYearInitial(product))) {
								<recertification-additional-questions-details [changeSet]="changeSet" [product]="product"></recertification-additional-questions-details>
							}
							<base-additional-questions-details [order]="order" [changeSet]="changeSet" [product]="product" [translateClientsData]="translateClientsData"
															   [useOriginalTranslations]="useOriginalTranslations"></base-additional-questions-details>
						}
					</div>
				</div>
			}

			@if (editable) {
				<div class="change-button" [ngClass]="{'collapsed': !detailsVisible}">
					<button id="change-button" nbButton status="warning" outline (click)="changeRequested.emit()">{{ 'common.edit' | translate }}</button>
				</div>
			}

		</div>
	</nb-card-body>
</nb-card>
